import ModuleMixin from '@/Mixins/ModuleMixin'

export default {
    mixins: [
        ModuleMixin
    ],

    data() {
        return {
            name: 'module.paymentMethod',
            allPaymentMethods: null
        }
    },

    methods: {
        all() {
            if(this.allPaymentMethods) {
                return Promise.resolve(this.allPaymentMethods)
            }

            return axios({
                method: 'get',
                url: route('api.paymentMethods.index'),
                params: {
                    scopes: ['allRecords'],
                }
            })
            .then(response => {
                this.$set(this, 'allPaymentMethods', response.data.data.data)
                return this.allPaymentMethods
            })
        }
    }
}